const state = {
  activeProd: [],
  inactiveProd: [],
  expiredProd: []
}
export default state
